import { Spinner } from './feedback';
import { useState, type FormEvent } from 'react';
import { api } from '../api/client';
import { Dialog } from './ui';
import { AuthField } from './AuthFields';
export function StepUpDialog({ onSuccess, onCancel }: { onSuccess: (until: string) => void; onCancel: () => void }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      const result = await api.stepUpVerify(code);
      onSuccess(result.steppedUpUntil);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : String(caught));
      setCode('');
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog
      title="ワンタイムコードで再確認"
      onClose={() => {
        if (!busy) onCancel();
      }}
      actions={
        <>
          <button className="btn" disabled={busy} onClick={onCancel}>
            {busy && <Spinner />}
            キャンセル
          </button>
          <button className="btn primary" form="step-up" disabled={busy}>
            {busy && <Spinner />}
            確認
          </button>
        </>
      }
    >
      <p>認証アプリのコード、または未使用のリカバリーコードを入力してください。確認は 5 分間有効です。</p>
      {error && <div className="alert danger">{error}</div>}
      <form id="step-up" onSubmit={(event) => void submit(event)}>
        <AuthField label="ワンタイムコード / リカバリーコード" value={code} onChange={setCode} code />
      </form>
    </Dialog>
  );
}
